import React from 'react'
import {ICopier} from '../../../../apis/copier/copier'
import TableHeader from '../../../../components/table/TableHeader'
import Text from '../../../../components/text/Text'
import TableLayout from '../../../../components/table/TableLayout'
import TableItem from '../../../../components/table/TableItem'
import WizImage from '../../../../components/image/WizImage'
import {useColor, useTag} from '../../../../utils/etc'
import {useDisplayNumber} from '../../../../utils/number'
import {useTime} from '../../../../utils/time'
import {useImage} from '../../../../utils/image'
import useNavigation from '../../../../hooks/useNavigation'
import Span from '../../../../components/text/Span'
import {useString} from '../../../../utils/string'

interface IProps {
    className?: string
    data?: ICopier[]
}

const CopierTable: React.FC<IProps> = ({className, data}) => {
    const {getNumberColor} = useColor()
    const {floorBalance, renderPercent} = useDisplayNumber()
    const {localTimeString} = useTime()
    const {renderThumbnail} = useImage()
    const {shortCutString} = useString()
    const {renderStateColor} = useTag()
    const {goCopierDetail} = useNavigation()

    return (
        <div className={`${className}`}>
            <TableHeader className={'grid-cols-[1fr_1fr_100px_150px] md:hidden'}>
                <Text>API Name</Text>
                <Text>Leader</Text>
                <Text>Profit</Text>
                <Text>Status</Text>
            </TableHeader>

            <TableLayout className={'shadow-[none] rounded-none'}>
                {data?.map((item, idx) => (
                    <TableItem
                        onClick={() => {
                            goCopierDetail(item?.id)
                        }}
                        key={idx}
                        className={
                            'grid-cols-[1fr_1fr_100px_150px] gap-[10px] md:grid-cols-2 md:gap-y-[10px] sm:grid-cols-2'
                        }>
                        <div className={'flex justify-between items-center md:justify-center'}>
                            <div className={'flex items-center space-x-[5px] md:flex-col md:space-x-0 md:gap-[5px]'}>
                                <Text className={'text-ti3 text-sub_blue hidden md:block'}>Copier</Text>
                                <WizImage
                                    src={renderThumbnail(item?.user_thumbnail)}
                                    className={'w-[36px] h-[36px] rounded-full sm:mt-[5px] border border-sub_blue'}
                                />
                                <Text className={'text-ti2 text-font02 sm:text-center pl-[5px] sm:pl-[0px]'}>
                                    {item?.status !== 'running'
                                        ? item?.status === 'deleted'
                                            ? '[Deleted]'
                                            : '[Paused]'
                                        : item?.name || shortCutString(item?.user_name, 5)}
                                </Text>
                            </div>
                        </div>

                        <div
                            className={
                                'flex items-center space-x-[5px] md:justify-center md:flex-col md:space-x-0 md:gap-[5px] sm:pt-[5px]'
                            }>
                            <Text className={'text-ti3 text-font_leader hidden md:block'}>Leader</Text>
                            <WizImage
                                src={renderThumbnail(item?.leader_thumbnail)}
                                className={'w-[36px] h-[36px] rounded-full sm:mt-[5px] border border-font_leader'}
                            />
                            <Text className={`lg:hidden text-ti2 text-font02 ${!item?.leader_name && 'text-font03'}`}>
                                {shortCutString(item?.leader_name, 3, 'end') || '[Deleted]'}
                            </Text>
                            <Text
                                className={`hidden lg:inline-block text-ti2 text-font02 sm:text-center ${
                                    !item?.leader_name && 'text-font03'
                                }`}>
                                {item?.leader_name || '[Deleted User]'}
                            </Text>
                        </div>
                        <div
                            className={
                                'md:text-right md:space-y-[10px] sm:text-left sm:space-y-0 sm:flex sm:gap-[5px] sm:items-center sm:justify-center sm:pt-[10px] sm:col-span-2'
                            }>
                            <Text className={'hidden sm:inline'}>Profit : </Text>
                            <Text className={`text-ti2 ${getNumberColor(item?.bot_score.earning)}`}>
                                {floorBalance(item?.bot_score.earning)}
                            </Text>
                            <Text className={`text-body3 ${getNumberColor(item?.bot_score.score)}`}>
                                ({renderPercent(item?.bot_score.score)})
                            </Text>
                        </div>
                        <div className={'space-y-[3px] md:space-y-[10px] sm:text-center sm:col-span-2'}>
                            <Span className={'hidden sm:inline'}>State : </Span>
                            <Text className={`sm:inline ${renderStateColor(item?.status === 'running')}`}>
                                {item?.status}
                            </Text>
                            <Text className={'text-body_comm text-font03 whitespace-nowrap'}>
                                Start At: {localTimeString(item?.start_at)}
                            </Text>
                            <Text className={'text-body3 text-font_red whitespace-nowrap'}>
                                Reason : {item?.bot?.reason}
                            </Text>
                        </div>
                    </TableItem>
                ))}

                {!data?.length && (
                    <TableItem className={'text-center'}>
                        <div>
                            <Text>No Items</Text>
                        </div>
                    </TableItem>
                )}
            </TableLayout>
        </div>
    )
}

export default CopierTable
